<template>
    <div v-if="chat" class="accepted-history" v-html="'취향 파악'" @click="onClickIdeal">
        <transition name="fade">
            <div v-show="friendMemoOpened" class="memo">
                <textarea
                    v-model="chat.memo"
                    @keydown="onKeydown"
                    :placeholder="$translate('PLACEHOLDER_FRIEND_MEMO')"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import chatService from '@/services/chat'
import debounce from '@/modules/debounce'

export default {
    name: 'AcceptedHistory',
    props: ['chat', 'user'],
    data: () => ({
        friendMemoOpened: false,
        showSbMemo: false,
    }),
    watch: {},
    methods: {
        onKeydown: debounce(async function (event) {
            const memo = event.target.value
            try {
                await chatService.update(this.chat.id, { memo })
            } catch (e) {}
        }, 200),
        onClickIdeal() {
            if (!this.chat) {
                this.$toast.error('ERROR_MEMO_NOT_FRIEND')
                return
            }

            this.$modal.custom({
                component: 'ModalAcceptedHistory',
                options: {
                    chat: this.chat,
                    user: this.user,
                    user_id: this.chat.user.id,
                },
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.accepted-history {
    width: 70px;
    height: 24px;
    text-align: center;
    padding-top: 4px;
    border-radius: 12px;
    background-color: $grey-01;
    color: #262289;
    font-size: 11px;
    font-family: NotoSans-Bold;
}
</style>
